import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import { Button, type ButtonProps } from '../Button';

/**
 * Step component to wrap the content of a wizard step.
 */
export function Step(props: { children: React.ReactNode }) {
    return <div {...props} className="h-full w-full" />;
}

export function StepHeading(props: { children: React.ReactNode; id?: string }) {
    return <h2 {...props} className="mb-4 text-ui-page-title" />;
}

export function StepDescription(props: { children: React.ReactNode }) {
    return <p {...props} className="mb-4 text-content-paragraph text-muted" />;
}

export function StepControls(props: { children: React.ReactNode }) {
    return (
        <div className="-mx-4 sticky bottom-0 mt-4 flex items-center gap-4 bg-gradient-to-t from-85% from-[var(--sp-color-bg-base)] to-100% to-transparent p-4">
            {props.children}
        </div>
    );
}

export function StepControlsSubmitButton(props: {
    submitLabel?: ButtonProps['label'];
    submitIcon?: ButtonProps['leadingIcon'];
    submitUpgradeKind?: boolean;
    onGoNext?: () => void;
    loading?: boolean;
    disabled?: boolean;
}) {
    return (
        <Button
            type={!props.onGoNext ? 'submit' : undefined}
            kind={props.submitUpgradeKind ? 'upgrade' : undefined}
            leadingIcon={props.submitIcon ?? Icon.ArrowRight}
            label={props.submitLabel ?? 'Next step'}
            loadable={props.loading ? [true] : undefined}
            onPress={props.onGoNext}
            disabled={props.disabled}
        />
    );
}

export function StepControlsBackButton(props: { onGoBack?: () => void; loading?: boolean }) {
    if (!props.onGoBack) {
        return null;
    }

    return (
        <Button kind="blank" label="Go back" onPress={props.onGoBack} disabled={props.loading} />
    );
}
